import { PageContentLayout } from '@acin/ui-core';
import styled from 'styled-components';

export const RegulationDetail = styled.div`
  height: 100%;
  overflow: hidden;
`;

export const ContentLayout = styled(PageContentLayout)`
  height: 100%;
  max-height: 100%;
  overflow: hidden;
`;
